import { Check, X, Circle } from "lucide-react";
import i18n from "../i18n";

// Traduction (Mon espace) : les textes suivent la langue active ; la page parente s'abonne aux changements via useTranslation.
const tr = (k, o) => i18n.t(k, o);

// Affiche les règles de la politique de mot de passe et coche en vert au fur et à mesure de la saisie.
export const PasswordPolicyChecklist = ({ policy, value = "", expiry, className = "" }) => {
  if (!policy) return null;
  const rules = [
    { key: "min", ok: value.length >= (policy.min_length || 8), label: tr("account:policy.auMoinsV0Caracteres", { v0: policy.min_length || 8 }) },
  ];
  if (policy.require_upper) rules.push({ key: "upper", ok: /[A-Z]/.test(value), label: tr("account:policy.uneLettreMajuscule") });
  if (policy.require_lower) rules.push({ key: "lower", ok: /[a-z]/.test(value), label: tr("account:policy.uneLettreMinuscule") });
  if (policy.require_digit) rules.push({ key: "digit", ok: /\d/.test(value), label: tr("account:policy.unChiffre") });
  if (policy.require_special) rules.push({ key: "special", ok: /[^A-Za-z0-9]/.test(value), label: tr("account:policy.unCaractereSpecial") });
  if (policy.prevent_reuse_last > 0)
    rules.push({ key: "reuse", ok: null, label: tr("account:policy.differentDeVosV0", { v0: policy.prevent_reuse_last }) });

  return (
    <div className={`rounded-xl border border-slate-200 bg-slate-50/70 p-3 ${className}`} data-testid="password-policy-checklist">
      <p className="text-xs font-medium text-slate-500 mb-2">{tr("account:policy.reglesDeMotDe")}</p>
      <ul className="space-y-1.5">
        {rules.map((r) => (
          <li
            key={r.key}
            data-testid={`policy-rule-${r.key}`}
            className={`flex items-center gap-2 text-xs transition-colors duration-200 ${
              r.ok === true ? "text-emerald-600" : r.ok === false ? "text-slate-500" : "text-slate-400"
            }`}
          >
            {r.ok === true ? (
              <Check className="w-3.5 h-3.5 shrink-0" />
            ) : r.ok === false ? (
              <X className="w-3.5 h-3.5 shrink-0 text-slate-300" />
            ) : (
              <Circle className="w-3 h-3 shrink-0 text-slate-300" />
            )}
            <span>{r.label}</span>
          </li>
        ))}
      </ul>
      {expiry && expiry.days_until_expiry != null && !expiry.expired && (
        <p
          data-testid="password-expiry-note"
          className={`mt-2.5 text-xs font-medium ${expiry.days_until_expiry <= 7 ? "text-amber-600" : "text-slate-500"}`}
        >
          {expiry.days_until_expiry <= 1
            ? tr("account:policy.votreMotDePasse")
            : tr("account:policy.votreMotDePasse2", { v0: expiry.days_until_expiry })}
        </p>
      )}
    </div>
  );
};
